import React, { Component, Suspense, lazy } from "react";
import { PageLayout, PageLayoutHeader, PageLayoutLeft, PageLayoutRight } from "Components/PageLayout";
import MenuList from "./MenuList";
import Loading from "Components/Loading";
import Ajax from "Pub/js/ajax";
import "./index.less";
import { getMulti } from "Pub/js/getMulti";
import { langCheck, GetQuery } from "Pub/js/utils.js";
import platform from "Pub/js/platform";
import CUSTOMIZEICON from "Assets/images/customizeIcon.png";
const { NCDiv } = platform.base;
const DragWithCom = platform.DragWithCom;
const DefaultSetting = lazy(() => import(/* webpackChunkName: "static/pages/Customize/DefaultSetting" */ "./DefaultSetting"));
const CommonData = lazy(() => import(/* webpackChunkName: "static/pages/Customize/CommonData" */ "./CommonData"));
const IfrContainer = lazy(() => import(/* webpackChunkName: "static/pages/Customize/IfrContainer" */ "./IfrContainer"));
class Customize extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeKey: "default",
            listArray: [],
            json: {}
        };
    }
    /**
     * 个性化页面页面
     * @param {String} key 菜单标识
     */
    hanleMenuListClick = key => {
        console.log(key);
        let { listArray } = this.state;
        // 为选中list 项添加 活跃标识
        listArray = listArray.map((item, index) => {
            delete item.active;
            if (item.url === key) {
                item.active = true;
            }
            return item;
        });
        this.setState({ listArray, activeKey: key });
    };
    /**
     *
     */
    loadCom = key => {
        let { json } = this.state;
        switch (key) {
            case "default":
                return (
                    <DefaultSetting title={langCheck("Customize-000039", "pages", json)} json={json} />
                ); /* 国际化处理： 默认设置*/
            case "commonData":
                return <CommonData title={langCheck("Customize-000027", "pages", json)} />; /* 国际化处理： 常用数据*/
            default:
                // let listItem = this.state.listArray.find((item)=>item.page_part_url === key);
                return <IfrContainer ifr={key} json={json} />;
        }
    };
    pageback = () => {
        // 返回首页
        this.props.history.push(`/`);
    };
    componentDidMount() {
        let { json } = this.state;
        let callback = json => {
            this.setState({
                json: json
            });
        };
        getMulti({
            moduleId: "Customize",
            domainName: "workbench",
            callback
        });
        document.addEventListener("keydown", this.handleHotKey);
        Ajax({
            url: `/nccloud/platform/appregister/queryindividualreg.do`,
            info: {
                name: langCheck("Customize-000042", "pages", json) /* 国际化处理： 个性化*/,
                action: langCheck("Customize-000005", "pages", json) /* 国际化处理： 查询*/
            },
            success: ({ data: { data } }) => {
                if (data) {
                    let listArray = data.map((item, index) => {
                        if (index === 0) {
                            return {
                                active: true,
                                name: item.name,
                                code: item.code,
                                url: item.page_part_url
                            };
                        }
                        return {
                            name: item.name,
                            code: item.code,
                            url: item.page_part_url
                        };
                    });
                    this.setState({
                        listArray,
                    });
                }
            }
        });
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleHotKey);
    }
    handleHotKey = e => {
        if (e && e.keyCode) {
            if (e.keyCode == 13) {
                let input = document.getElementsByClassName("refer-input") && [
                    ...document.getElementsByClassName("refer-input")
                ];
                let tabIndex = e.target && e.target.tabIndex;
                if (tabIndex === 6) {
                    input[0].focus();
                    return;
                }
                input[tabIndex + 1].focus();
            }
        }
    };
    render() {
        let { listArray, json } = this.state;
        return (
            <PageLayout
                className='nc-workbench-ownpage-all customize-layout'
                header={
                    <PageLayoutHeader pageback={this.pageback}>
                        <div className='pageLayoutHeaderOwn'>
                            {
                                !this.props.hideBackBtn && <i className='iconfont icon-danjufanhuiicon' onClick={this.pageback} />
                            }
                            <img src={CUSTOMIZEICON} width='24' height='24' />
                            <NCDiv fieldid={langCheck("Customize-000049", "pages", json)} areaCode={NCDiv.config.Title}>
                                {langCheck("Customize-000049", "pages", json) /* 国际化处理： 业务设置*/}
                            </NCDiv>
                        </div>
                    </PageLayoutHeader>
                }>
                <DragWithCom
                    defLeftWid="200px"
                    leftMinWid="200px"
                    leftDom={
                        <div className="nc-workbench-ownpage-left" style={{ minWidth: 200 }}>
                            <div className='customize-left workbench-scroll'>
                                {listArray.length > 0 ? (
                                    <MenuList onClick={this.hanleMenuListClick} listArray={listArray} />
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                    }
                    rightDom={
                        <PageLayoutRight>
                            <Suspense fallback={<Loading />}>
                                {listArray.length > 0 ? this.loadCom(this.state.activeKey) : ""}
                            </Suspense>
                        </PageLayoutRight>
                    }
                />
            </PageLayout>
        );
    }
}
export default Customize;
